import MyTable from "components/UIElements/MyTable";
import { useParams ,useLocation } from "react-router-dom";
import { useContext } from 'react';
import { AuthContext } from 'shared/context/auth-context'
import  EndPoints from 'shared/endPoints/EndPoints.json';

export default function Packages() {
    const { id } = useParams();
    const endPoint = `${EndPoints.CONTRACT.GETCONTRACTCHANGES}/?id=${id}`
    const location = useLocation();
    const exportFilename = `Anytime_BTM_Profil_Changes_History_Contract_${location.state.policyNumber}`;
    const { roleUser } = useContext(AuthContext)
    const allRoles = ['AnyTimeAdmin', 'AnyTime', 'GT']

    const columns = [
        {
            title: 'Αρ Συμβολαίου',
            dataIndex: 'policyNumber',
            key: 'policyNumber',
            showOnRoles: allRoles,
        },
        {
            title: 'Αριθ. Κυκλοφορίας',
            key: 'plateNumber',
            dataIndex: 'plateNumber',
            showOnRoles: allRoles,
        },
        {
            title: 'Κινητό',
            key: 'mobilePhone',
            dataIndex: 'mobilePhone',
            showOnRoles: allRoles,
        },
        {
            title: 'Email',
            key: 'email',
            dataIndex: 'email',
            showOnRoles: allRoles,
        },
        {
            title: 'Επώνυμο',
            key: 'lastName',
            dataIndex: 'lastName',
            showOnRoles: allRoles,
        },
        {
            title: 'Όνομα',
            key: 'firstName',
            dataIndex: 'firstName',
            showOnRoles: allRoles,
        },
        {
            title: 'Χιλιόμετρα Πακέτου',
            key: 'kilometers',
            dataIndex: 'kilometers',
            showOnRoles: allRoles,
        },
        {
            title: 'Ημ/νία Έναρξης Συμβολαίου',
            key: 'startDate',
            dataIndex: 'startDate',
            showOnRoles: allRoles,
        },
        {
            title: 'Ημ/νία Λήξης Συμβολαίου',
            key: 'endDate',
            dataIndex: 'endDate',
            showOnRoles: allRoles,
        },
        {
            title: 'Ημ/νία καταχώρησης',
            key: 'dateCreated',
            dataIndex: 'dateCreated',
            showOnRoles: ['AnyTime', 'GT'],
        },
        {
            title: 'Σχόλια',
            key: 'comments',
            dataIndex: 'comments',
            showOnRoles: allRoles,
        },
    ].filter(item => item.showOnRoles.indexOf(roleUser) !== -1);

    return <MyTable columns={columns} endPoint={endPoint} exportFilename={exportFilename} ContractTab/>


}